import Cookies from 'js-cookie';

import { localStorageNames } from '@shared/constants/local-storage-names';
import { queryClient } from '@src/core/api/query-client';
import { useAssistantStore } from '@features/assistant/store/assistant-store';
import { useAuthStore } from '@src/core/store/auth-store';

export const deleteCredentials = () => {
  useAuthStore.getState().clearAccessToken();
  Cookies.remove(localStorageNames.refreshToken);
  // Per-user assistant state must not outlive the session: the next login in
  // this tab would otherwise inherit the previous user's conversation id.
  useAssistantStore.getState().reset();
  queryClient.removeQueries({ queryKey: ['assistant'] });
};
